import { Component, OnInit, Input } from '@angular/core';
import { DVFormGroup } from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { SharedService } from 'src/app/shared/shared.service';

@Component({
  selector: 'app-package-location',
  templateUrl: './package-location.component.html',
  styleUrls: ['./package-location.component.css']
})
export class PackageLocationComponent implements OnInit {

  @Input() packageForm: DVFormGroup;

  constructor(
    private sharedApi: SharedService
  ) { }
  countries = [];
  cities = [];
  selectedCountry = '';
  ngOnInit() {
    this.sharedApi.getAllCountries().subscribe(response => {
      this.countries = response.data.countries;
    });
    this.packageForm.controls.countryId.valueChanges.subscribe(newCountryId => {
      this.getCities(newCountryId);
    });
  }

  getCities(countryId) {
    this.selectedCountry = countryId;
    if (countryId) {
      this.sharedApi.getAllCities(countryId).subscribe(response => {
        this.cities = response.data.cities;
      });
    } else {
      this.cities = [];
    }
  }

  getSearchableCityName() {
    try {
      if (this.packageForm.value.cityId && this.selectedCountry) {
        const country = this.countries.find(c => Number(c.id) === Number(this.selectedCountry));
        const city = this.cities.find(c => Number(c.id) === Number(this.packageForm.controls.cityId.value));
        return `${city.name}, ${country.name}`;
      }
    } catch (err) {
      return null;
    }
    return null;
  }

}
